import { DropdownMenu } from '#/components/ui/DropdownMenu';
import { Icon } from '#/components/ui/icons';
import type { ReturnsTimeframeId } from '#/components/ui/returnsTimeframe';

const RETURNS_TIMEFRAME_OPTIONS: Array<{
  id: ReturnsTimeframeId;
  label: string;
}> = [
  { id: '5Y', label: '5 Years' },
  { id: '1Y', label: '1 Year' },
];

export function ReturnsTimeframeFilter({
  timeframe,
  onChange,
  compact = false,
  trackContext,
}: {
  timeframe: ReturnsTimeframeId;
  onChange: (nextTimeframe: ReturnsTimeframeId) => void;
  compact?: boolean;
  /**
   * Analytics grouping bucket (`data-track-context`) for the menu items. This
   * is a shared control rendered in several sections, so the parent passes the
   * context identifying where the change came from.
   */
  trackContext?: string;
}) {
  const selectedLabel = RETURNS_TIMEFRAME_OPTIONS.find(
    (option) => option.id === timeframe,
  )?.label;

  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger
        className={compact ? 'text-static-14 gap-6 px-12 py-8' : 'self-start'}
      >
        <Icon
          id="plus-minus"
          size={compact ? 10 : 12}
          className="text-fg-header shrink-0"
        />
        <span
          className={
            compact
              ? 'text-fg-header text-static-14 font-semibold'
              : 'text-fg-header font-semibold'
          }
        >
          {selectedLabel ?? '5 Years'}
        </span>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Positioner sideOffset={4}>
          <DropdownMenu.Popup>
            <DropdownMenu.Viewport>
              {RETURNS_TIMEFRAME_OPTIONS.map((option) => (
                <DropdownMenu.Item
                  key={option.id}
                  onClick={() => onChange(option.id)}
                  data-track="returns_timeframe"
                  data-track-label={option.label}
                  data-track-context={trackContext}
                >
                  {option.label}
                </DropdownMenu.Item>
              ))}
            </DropdownMenu.Viewport>
          </DropdownMenu.Popup>
        </DropdownMenu.Positioner>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
